import { render, staticRenderFns } from "./excellentDetail.vue?vue&type=template&id=667c2fd6&scoped=true"
import script from "./excellentDetail.vue?vue&type=script&lang=js"
export * from "./excellentDetail.vue?vue&type=script&lang=js"
import style0 from "./excellentDetail.vue?vue&type=style&index=0&id=667c2fd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667c2fd6",
  null
  
)

export default component.exports